<template>
  <vs-row vs-type="flex" vs-w="12" id="giroReportByHour"
    class="sale-box-shadow low-border-radius bg-white bg-white p-2">
    <vs-row vs-type="flex" vs-w="12" id="giroReportByHourTitle" class="p-1">
      <span v-if="!stop" class="text-xsmall text-secondary bold">
        Saatlik Ciro Analizi
      </span>
    </vs-row>
    <vs-row vs-type="flex" vs-w="12" id="giroReportByHourChips">
      <vs-col vs-type="flex" vs-sm="12" vs-md="6" vs-lg="6" class="px-1">
        <vs-row vs-type="flex" vs-w="12">
          <vs-row vs-type="flex" vs-w="12">
            <span class="w-full text-dark text-small weight-600">
              {{selectedTimeRange + ' En Çok Satış Yapılan Saat Aralığı'}}
            </span>
          </vs-row>
          <vs-row vs-type="flex" vs-w="12">
            <span class="w-full text-primary text-medium bold">
              {{reportData.max}}
            </span>
          </vs-row>
        </vs-row>
      </vs-col>
      <vs-col vs-type="flex" vs-sm="12" vs-md="6" vs-lg="6" class="px-1">
        <vs-row vs-type="flex" vs-w="12">
          <vs-row vs-type="flex" vs-w="12">
            <span class="w-full text-dark text-small weight-600">
              {{selectedTimeRange + ' En Az Satış Yapılan Saat Aralığı'}}
            </span>
          </vs-row>
          <vs-row vs-type="flex" vs-w="12">
            <span class="w-full text-primary text-medium bold">
              {{reportData.min}}
            </span>
          </vs-row>
        </vs-row>
      </vs-col>
    </vs-row>
    <vs-row vs-w="12" id="giroReportLineChart">
      <apexchart type="line" height="350" :options="getChartOptions" :series="getReportDataHours()" />
    </vs-row>
    <vs-row v-if="!stop" vs-type="flex" vs-w="12" class="pt-3 pb-1" vs-justify="center" vs-align="center">
      <span @click="openDetailPage" class="text-secondary text-xsmaller bold underline cursor-pointer">
        Detay Sayfasına Git
      </span>
    </vs-row>
  </vs-row>
</template>

<script>
  export default {
    props: {
      stop: {
        required: true,
        type: Boolean
      },
      reportData: {
        required: true,
        type: Object
      },
      selectedTimeRange: {
        required: true,
        type: String
      },
    },
    data() {
      return {
        themeColors: ['#FF3D67', '#FF9F40', '#4BC0C0', '#FFCD56', '#36A2EB', '#1a1a2e', '#8d93ab', '#ec0101',
          '#fbe2e5'
        ],
      }
    },
    computed: {
      getChartOptions() {
        return {
          chart:{
            width:'100%'
          },
          dataLabels: {
            enabled: false,
          },
          xaxis: {
            categories: this.reportData && this.reportData.values != null ? this.reportData.values.map(x => x.name) : [],
            axisBorder: {
              show: true,
              color: '#78909C',
              height: 1,
              width: '100%',
            },
            labels: {
              formatter: function (value) {
                if (!value) return "";
                if (value.length == 1) return '0' + value + ':00';
                else return value + ':00';
              },
            }
          },
          yaxis: {
            labels: {
              formatter: function (value) {
                var formatter = new Intl.NumberFormat('tr-TR', {
                  style: 'currency',
                  currency: 'TRY',
                });
                return formatter.format(value);
              },
            }
          },
          stroke: {
            curve: 'smooth'
          },
          markers: {
            size: 5,
            colors: this.themeColors,
            strokeColors: '#fff',
            strokeWidth: 2,
            strokeOpacity: 0.9,
            fillOpacity: 1,
            strokeDashArray: 0,
            shape: 'circle',
            radius: 2,
          }
        };
      }
    },
    methods: {
      getReportDataHours() {
        var obj = [{
          name: "Ciro",
          data: this.reportData && this.reportData.values != null ? this.reportData.values.map(x => x.value) : []
        }];
        return obj;
      },
      openDetailPage() {
        this.$router.push('/pages/reports/giro-by-time').catch(() => {})
      }
    }
  }

</script>

<style>
  #giroReportLineChart {
    display: table !important;
  }

</style>
